import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import AddIcon from '@mui/icons-material/Add'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { BacktestFolder } from '../../../hooks/useBacktestFolders'
import FolderNameDialog from './FolderNameDialog'

type FolderRailProps = {
  folders: BacktestFolder[]
  selectedFolderId: string | null
  onSelectFolder: (folderId: string | null) => void
  onCreateFolder: (name: string) => void
  onRenameFolder: (folderId: string, name: string) => void
  onDeleteFolder: (folderId: string) => void
}

function FolderRail({
  folders,
  selectedFolderId,
  onSelectFolder,
  onCreateFolder,
  onRenameFolder,
  onDeleteFolder,
}: FolderRailProps) {
  const [dialogState, setDialogState] = useState<{
    mode: 'create' | 'rename'
    folder?: BacktestFolder
  } | null>(null)
  const [menuFolder, setMenuFolder] = useState<{
    folder: BacktestFolder
    anchor: HTMLElement
  } | null>(null)

  return (
    <>
      <Box display={'flex'} gap={1} alignItems={'center'} flexWrap={'wrap'} px={1} py={0.5}>
        <Chip
          label={'All Favorites'}
          color={selectedFolderId === null ? 'primary' : undefined}
          variant={selectedFolderId === null ? 'filled' : 'outlined'}
          onClick={() => onSelectFolder(null)}
          size={'small'}
        />
        {folders.map((folder) => (
          <Chip
            key={folder.id}
            label={folder.name}
            color={selectedFolderId === folder.id ? 'primary' : undefined}
            variant={selectedFolderId === folder.id ? 'filled' : 'outlined'}
            onClick={() => onSelectFolder(folder.id)}
            onDelete={(e) => setMenuFolder({ folder, anchor: e.currentTarget as HTMLElement })}
            deleteIcon={<MoreVertIcon fontSize={'small'} />}
            size={'small'}
          />
        ))}
        <IconButton
          size={'small'}
          onClick={() => setDialogState({ mode: 'create' })}
          aria-label={'New folder'}
        >
          <AddIcon fontSize={'small'} />
        </IconButton>
      </Box>

      <Menu anchorEl={menuFolder?.anchor} open={!!menuFolder} onClose={() => setMenuFolder(null)}>
        <MenuItem
          onClick={() => {
            if (menuFolder) setDialogState({ mode: 'rename', folder: menuFolder.folder })
            setMenuFolder(null)
          }}
        >
          Rename
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (menuFolder) {
              onDeleteFolder(menuFolder.folder.id)
              if (selectedFolderId === menuFolder.folder.id) onSelectFolder(null)
            }
            setMenuFolder(null)
          }}
        >
          Delete
        </MenuItem>
      </Menu>

      <FolderNameDialog
        open={!!dialogState}
        mode={dialogState?.mode || 'create'}
        initialName={dialogState?.folder?.name}
        onClose={() => setDialogState(null)}
        onSubmit={(name) => {
          if (dialogState?.mode === 'rename' && dialogState.folder) {
            onRenameFolder(dialogState.folder.id, name)
          } else {
            onCreateFolder(name)
          }
        }}
      />
    </>
  )
}

export default FolderRail
